import actionTypes from "../../actions/actionTypes";

const _initState = {
  isLoading: false,
  list: [],
  item: null,
};

const zpCStavZiadosti = (state = _initState, action) => {
  switch (action.type) {
    case actionTypes.GET_ZP_C_STAV_ZIADOSTI_REQUEST:
      return { ...state, isLoading: true };

    case actionTypes.GET_ZP_C_STAV_ZIADOSTI_SUCCESS:
      return { ...state, isLoading: false, list: action.res.Data };

    case actionTypes.GET_ZP_C_STAV_ZIADOSTI_FAILURE:
      return _initState;

    case actionTypes.CHANGE_STAV_ZIADOSTI:
      return { ...state, item: action.data };

    default:
      return state;
  }
};

export default zpCStavZiadosti;
